const SUBDOMAIN_REGEX = /.*\.(.*?\.(?:com|net))/;

// TODO: Remove this in favor of using the environment.js file (getEnvironment())

/**
 *
 * @param {string} hostname - The hostname from which to extract the domain. Defaults to the current location's hostname.
 * @returns {string} The extracted domain if a match is found; otherwise, returns the original hostname.
 */
function getDomain(hostname = window.location.hostname) {
	const matches = SUBDOMAIN_REGEX.exec(hostname);
	if (matches === null) {
		return hostname;
	}

	return matches[1];
}

export const SECURE = typeof window !== 'undefined' && window.location.protocol === 'https:';
export const DOMAIN =
	typeof window !== 'undefined' ? getDomain(window.location.hostname) : '.abcmouse.com';
export const HOSTNAME =
	typeof window !== 'undefined' ? window.location.hostname : 'www.abcmouse.com';
export const IS_LOCAL_DEVELOPMENT =
	typeof window !== 'undefined' && window.location?.hostname?.includes('localhost');
